export default __webpack_public_path__ + "static/media/kalkulatorTutorialFinal.37d1198c.mp4";